export const Decline = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.2C7.13988 3.2 3.19999 7.1399 3.19999 12C3.19999 16.8601 7.13988 20.8 12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.1399 16.8601 3.2 12 3.2ZM0.799988 12C0.799988 5.81441 5.8144 0.800003 12 0.800003C18.1856 0.800003 23.2 5.81441 23.2 12C23.2 18.1856 18.1856 23.2 12 23.2C5.8144 23.2 0.799988 18.1856 0.799988 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.09116 17.2735C6.62253 16.8049 6.62253 16.0451 7.09116 15.5765L15.5764 7.09117C16.0451 6.62254 16.8049 6.62254 17.2735 7.09117C17.7421 7.5598 17.7421 8.3196 17.2735 8.78823L8.78821 17.2735C8.31958 17.7421 7.55979 17.7421 7.09116 17.2735Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.09116 7.09117C7.55979 6.62254 8.31958 6.62254 8.78821 7.09117L17.2735 15.5765C17.7421 16.0451 17.7421 16.8049 17.2735 17.2735C16.8049 17.7421 16.0451 17.7421 15.5764 17.2735L7.09116 8.78823C6.62253 8.3196 6.62253 7.5598 7.09116 7.09117Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
